import { FlaskConical } from "lucide-react";
import { cn } from "@/lib/utils";

export const DemoBadge = ({ className = "" }) => (
  <span
    className={cn("inline-flex items-center gap-1.5 rounded-full border border-gold/60 bg-gold/15 px-2.5 py-1 text-[11px] font-semibold text-[#8a6d22] dark:text-gold", className)}
    data-testid="demo-data-badge"
    title="Toutes les données affichées sont fictives"
  >
    <FlaskConical className="h-3.5 w-3.5" />
    Données fictives
  </span>
);
